import { fetchProducts } from '~/js/utils/products-and-collections';
import Swiper, { Navigation, Scrollbar } from 'swiper';
import { fetchRecommendedProducts } from '~js/utils/products-and-collections';

const recommendedProducts = (recommendedProductIds, productId) => ({
  swiperInstance: null,
  recommendedProducts: [],

  async init() {
    const productsIds =
      recommendedProductIds ||
      (await fetchRecommendedProducts('COMPLEMENTARY', `gid://shopify/Product/${productId}`)).products.nodes.map(
        (product) => product.id,
      );
    const productsObj = await fetchProducts(productsIds);
    this.recommendedProducts = productsIds.map((id) => productsObj[id]);
    this.swiperEl = this.$refs.swiper;
    this.buildSwiper();

    // UPDATE SLIDES whenever recommendedProducts changes
    this.$watch('recommendedProducts', () => {
      this.swiperInstance.update();
      this.swiperInstance.slideTo(0, 750);
    });
  },

  buildSwiper() {
    if (!this.swiperEl) {
      return;
    }

    this.swiperInstance = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      modules: [Navigation, Scrollbar],
      scrollbar: {
        el: this.swiperEl.querySelector('.swiper-scrollbar'),
        hide: true,
      },
      navigation: {
        nextEl: this.swiperEl.querySelector('.swiper-btn-next'),
        prevEl: this.swiperEl.querySelector('.swiper-btn-prev'),
        disabledClass: 'pointer-events-none opacity-30',
      },
      spaceBetween: 16,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      breakpoints: {
        1024: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 16,
        },
      },
    });

    setTimeout(() => {
      this.swiperInstance.init();
    }, 0);
  },
});

export default recommendedProducts;
